
import { useEffect, useState } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Handle scroll to toggle header background/shadow
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    // Cleanup on unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || isMobileMenuOpen ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="#" className="flex items-center cursor-pointer">
            <img
              src="https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/9376d72cbfbe1ae88b1de1492c3fd82c.png"
              alt="宝珠運輸"
              className="h-8 md:h-10"
            />
          </a>

          {/* Desktop navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <a
              href="#vision"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-teal-500' : 'text-gray-900 hover:text-teal-500'
              }`}
            >
              企業の思い
            </a>
            <a
              href="#news"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-teal-500' : 'text-gray-900 hover:text-teal-500'
              }`}
            >
              ニュース
            </a>
            <a
              href="#service"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-teal-500' : 'text-gray-900 hover:text-teal-500'
              }`}
            >
              事業内容
            </a>
            <a
              href="#company"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-teal-500' : 'text-gray-900 hover:text-teal-500'
              }`}
            >
              企業情報
            </a>
            <a
              href="#contact"
              className="px-6 py-2 bg-teal-500 text-white text-sm font-medium rounded-full hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              お問い合わせ
            </a>
          </nav>

          {/* Mobile menu toggle button */}
          <button
            onClick={toggleMobileMenu}
            className="md:hidden w-10 h-10 flex flex-col items-center justify-center gap-1.5 cursor-pointer"
            aria-label="Toggle menu"
          >
            <span
              className={`w-6 h-0.5 bg-gray-900 transition-all duration-300 ${
                isMobileMenuOpen ? 'rotate-45 translate-y-2' : ''
              }`}
            ></span>
            <span
              className={`w-6 h-0.5 bg-gray-900 transition-all duration-300 ${
                isMobileMenuOpen ? 'opacity-0' : ''
              }`}
            ></span>
            <span
              className={`w-6 h-0.5 bg-gray-900 transition-all duration-300 ${
                isMobileMenuOpen ? '-rotate-45 -translate-y-2' : ''
              }`}
            ></span>
          </button>
        </div>
      </div>

      {/* Mobile navigation panel */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          isMobileMenuOpen ? 'max-h-80' : 'max-h-0'
        }`}
      >
        <div className="bg-white border-t border-gray-100">
          <nav className="flex flex-col py-2">
            <a
              href="#vision"
              className="px-6 py-3 text-sm font-medium text-gray-900 hover:bg-gray-50 cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              企業の思い
            </a>
            <a
              href="#news"
              className="px-6 py-3 text-sm font-medium text-gray-900 hover:bg-gray-50 cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              ニュース
            </a>
            <a
              href="#service"
              className="px-6 py-3 text-sm font-medium text-gray-900 hover:bg-gray-50 cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              事業内容
            </a>
            <a
              href="#company"
              className="px-6 py-3 text-sm font-medium text-gray-900 hover:bg-gray-50 cursor-pointer"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              企業情報
            </a>
            <a
              href="#contact"
              className="mx-6 my-2 px-6 py-2.5 bg-teal-500 text-white text-sm font-medium rounded-full hover:bg-teal-600 transition-colors text-center cursor-pointer whitespace-nowrap"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              お問い合わせ
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
}
